import * as types from './constants';

// Get My Creators Connected
export const getMyCreatorsConnectedRequest = data => (
  { type: types.GET_MY_CREATORS_CONNECTED_REQUEST, payload: data }
);

export const getMyCreatorsConnectedDone = data => (
  { type: types.GET_MY_CREATORS_CONNECTED_DONE, payload: data }
);

export const getMyCreatorsConnectedFailed = errors => (
  { type: types.GET_MY_CREATORS_CONNECTED_FAILED, payload: errors }
);

export const getMyCreatorsConnectedReset = () => (
  { type: types.GET_MY_CREATORS_CONNECTED_RESET }
);

// Operations
export const toggleMyCreatorsConnected = data => (
  { type: types.TOGGLE_MY_CREATORS_CONNECTED, payload: data }
);

export const toggleAllMyCreatorsConnected = data => (
  { type: types.TOGGLE_ALL_MY_CREATORS_CONNECTED, payload: data }
);

export const setFilter = data => (
  { type: types.SET_MY_CREATORS_CONNECTED_FILTER, payload: data }
);

export const setAllFilters = data => (
  { type: types.SET_MY_CREATORS_CONNECTED_ALL_FILTERS, payload: data }
);

export const clearFilters = (filterToUpdate, mobile) => (
  { type: types.CLEAR_MY_CREATORS_CONNECTED_FILTERS, payload: { filterToUpdate, mobile } }
);

export const myCreatorsConnectedSetPage = data => (
  { type: types.MY_CREATORS_CONNECTED_SET_PAGE, payload: data }
);